import { useMutation } from "@apollo/client/react";
import mixpanel from "mixpanel-browser";
import React, { useEffect } from "react";
import { Controller } from "react-hook-form";

import { EmailExportTypeRadioButton } from "./EmailExportTypeRadioButton";
import EDIT_USER from "../../graphql/mutations/EditUser";
import { alert } from "../common/Alert";

export function EmailExportTypeForm({
  control,
  setValue,
  data,
  isForAccountSetting = false,
  refetch,
}) {
  const [editUser] = useMutation(EDIT_USER);

  const handleExportTypeChange = (shouldEmbed) => {
    editUser({
      variables: {
        shouldEmbedEmailExports: shouldEmbed,
      },
    })
      .then(() => {
        mixpanel.track("Updated Account Setting", {
          settingName: "Auto Export Email Type",
          settingKey: "user.shouldEmbedEmailExports",
          settingValue: shouldEmbed,
        });
        alert("success", "Account updated successfully.");
        refetch();
      })
      .catch((err) => alert("error", err.message));
  };

  useEffect(() => {
    if (data?.user?.shouldEmbedEmailExports) {
      setValue(
        "exportType",
        data?.user?.shouldEmbedEmailExports ? "embeddedText" : "link",
      );
    }
  }, [data, setValue]);

  return (
    <Controller
      control={control}
      rules={{
        required: true,
      }}
      render={({ field: { onChange, value } }) => (
        <div className="md:flex-1 flex flex-col lg:flex-row lg:items-center lg:space-x-4 mb-6">
          <EmailExportTypeRadioButton
            title={"Email as link"}
            description={`${
              isForAccountSetting
                ? "Automatically exported notes"
                : "This note"
            } will be exported as an email containing
                    a secure link that will direct to a webpage
                    from which the note can be accessed.`}
            onChange={(e) => {
              onChange(e);
              if (isForAccountSetting) handleExportTypeChange(false);
            }}
            value={"link"}
            currentValue={value}
          />
          <EmailExportTypeRadioButton
            title={"Email as embedded text"}
            description={`${
              isForAccountSetting
                ? "Automatically exported notes"
                : "This note"
            } will be exported as an email containing the
                note's text content. Attachments cannot be included in
                the email.`}
            onChange={(e) => {
              onChange(e);
              if (isForAccountSetting) handleExportTypeChange(true);
            }}
            value={"embeddedText"}
            currentValue={value}
          />
        </div>
      )}
      name="exportType"
      defaultValue={
        data?.user?.shouldEmbedEmailExports ? "embeddedText" : "link"
      }
    />
  );
}
